export default "__VITE_ASSET__85NcBPYh__"